module.exports = __webpack_public_path__ + "media/app/fonts/catamaran-v4-latin-regular-e8b6c2f772958ead74a071061a84d0f5.woff";